import { GetAsync } from 'common/httpRequests';
import { BACKEND } from 'constants/settings';
import { createContext, useEffect, useState } from 'react';
import { loginCustomerAction } from 'redux/slices/customer';
import { store } from 'redux/store';

type AuthContextProps = {
  allowed: boolean | '';
  isLoading: boolean;
  fetchCustomerData: () => Promise<any>;
};

const AuthContext = createContext<AuthContextProps | null>(null);
const AuthProvider: React.FC<{ children }> = ({ children }) => {
  const [allowed, setAllowed] = useState<boolean | ''>('');
  const [isLoading, setIsLoading] = useState(true);

  const fetchCustomerData = async () => {
    const currentCustomerId = window.location.pathname.split('/')[1];
    setIsLoading(true);
    try {
      if (currentCustomerId) {
        const response = await GetAsync(
          `${BACKEND}/api/customerservice/Customer/${currentCustomerId}`
        );
        if ([201, 200, 204].includes(response.status)) {
          store.dispatch(loginCustomerAction(response.data));
          setAllowed(true);
          return response.data;
        } else {
          setAllowed(false);
        }
      } else {
        setAllowed(false);
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchAPIs = async () => {
      await fetchCustomerData();
    };
    fetchAPIs();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        allowed,
        isLoading,
        fetchCustomerData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
